export async function apiFetch(path, options = {}) {
  const res = await fetch(`/api${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  if (!res.ok) {
    let error = `Request failed (${res.status}).`;
    try {
      const data = await res.json();
      if (data.error) error = data.error;
    } catch (e) {
      /* noop */
    }
    const err = new Error(error);
    err.status = res.status;
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
}

export async function transcribeVoice(blob) {
  const res = await fetch(`/api/sessions/voice/transcribe`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": blob.type || "audio/webm" },
    body: blob,
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || "Could not transcribe that recording.");
  }
  const data = await res.json();
  return data.text;
}

export async function synthesizeSpeech(text) {
  const res = await fetch(`/api/sessions/voice/speak`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ text }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || "Could not generate speech for that reply.");
  }
  const blob = await res.blob();
  return URL.createObjectURL(blob);
}
